module.exports = __webpack_public_path__ + "media/smart_sales/house_en-27636b52.webp";